import React, {Component} from "react";
import {connect} from "react-redux";
import {Card} from "components/Card/Card.jsx";
import SimpleReactValidator from "simple-react-validator";
import {withRouter} from "react-router-dom";
import {Grid, Row, Col} from "react-bootstrap";
import {MdNavigateNext, MdNavigateBefore} from 'react-icons/md';
import BrandLogo from "./BrandLogo";
import TagLayoutInfo from './TagLayoutInfo';
import {helperFunctions as HF} from "../../../helper/helperFunctions";
import AsyncSelect from "react-select/lib/Async";
import {createOrderActions} from "../../../redux/actions/create-order-actions";
import {objectsConstants as OC} from "../../../redux/constant/objects-constant";
import Select from "react-select";

// import {MultiSelect} from "react-multi-select-component";


class LookupPO extends Component {
    constructor(props) {
        super(props);
        this.validatorBrand = new SimpleReactValidator();
        this.state = {
            submitted: false,
            clearState: false,

            //    async
            selectValue: {},
            attribute_id: "",
            attribute_name: "",
            brand_id: "",
            def_id: "",
            filter: "",
            typingTimeout: 0,
            filters_flat_array: [],
            dropdown_data: {},
            test: []
        };
    }

    // for async start
    componentDidMount = () => {
        let temp_obj = {};
        let data_obj = {};
        this.props.filterAttributes.forEach(item => {
            let {id, brand_id, db_column, brand_data_definition_id, grid_label} = item.attribute;
            temp_obj[id] = {
                brand_id,
                attribute_id: id,
                attribute_name: grid_label,
                def_id: brand_data_definition_id,
                db_column,
                filter_val: "",
                search: ""
            }
            data_obj[id] = [];
        });
        temp_obj.brand_data = {
            brand:this.props.selectedBrand,
            productAttributes: this.props.productAttributes
        };
        this.setState({
            ...this.state,
            selectValue: temp_obj,
            dropdown_data: data_obj
        }, () => {
            this.handleSelectBlur();
        });
    };


    reset = () => {
        this.setState({
            selectValue: {}
        }, () => {
            setTimeout(() => {
                this.props.refreshList();
            }, 500);
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.filterAttributes !== prevProps.filterAttributes) {
            let temp_obj = {};
            let data_obj = {};
            this.props.filterAttributes.forEach(item => {
                let {id, brand_id, db_column, brand_data_definition_id, grid_label} = item.attribute;
                temp_obj[id] = {
                    brand_id,
                    attribute_id: id,
                    attribute_name: grid_label,
                    def_id: brand_data_definition_id,
                    db_column,
                    filter_val: "",
                    search: ""
                }
                data_obj[id] = [];
            });
            temp_obj.brand_data = {
                brand:this.props.selectedBrand,
                productAttributes: this.props.productAttributes
            }
            this.setState({
                ...this.state,
                selectValue: temp_obj,
                dropdown_data: data_obj
            }, () => {
                this.handleSelectBlur();
            });

        }
    }

    loadOptions = (query, callback, att_id) => {
        let data = {...this.state.selectValue};
        if (query) {
            data[att_id].search = query;
            const self = this;
            if (self.state.typingTimeout) {
                clearTimeout(self.state.typingTimeout);
            }

            let cloned = this.state.dropdown_data[att_id];
            let filtered = [];
            if (cloned.length > 1) {
                filtered = cloned.filter(item => {
                    if (item.value.includes(query)) {
                        return true;
                    }
                    return false;
                })
            }
            if (filtered.length > 0) {
                callback(filtered);
                return
            }
            self.setState({
                ...self.state,
                typingTimeout: setTimeout(function () {
                    self.props
                        .getDropDownList(data)
                        .then(response => {
                            console.log('data', response)
                            let options = [];
                            options = response;
                            this.setState({
                                dropdown_data: {
                                    ...this.state.dropdown_data,
                                    [att_id]: options
                                }
                            })
                            callback(options);
                        });
                }, 500)

            });
        } else {
            callback(this.state.dropdown_data[att_id])
        }
    };

    onSelectInput = (query, att_id) => {
        let data = {...this.state.selectValue};
        if (query) {
            data[att_id].search = query;
            const self = this;
            if (self.state.typingTimeout) {
                clearTimeout(self.state.typingTimeout);
            }

            let cloned = this.state.dropdown_data[att_id];
            let filtered = [];
            if (cloned.length > 1) {
                filtered = cloned.filter(item => {
                    if (item.value && item.value.includes(query)) {
                        return true;
                    }
                    return false;
                })
            }
            if (filtered.length > 0) {
                return filtered;
            }
            let arr = [];
            self.setState({
                typingTimeout: setTimeout(function () {
                    self.props
                        .getDropDownList(data)
                        .then(response => {
                            let {dropdown_data} = self.state;
                            for (let key in dropdown_data) {
                                dropdown_data[key] = response[key];
                            }
                            self.setState({
                                dropdown_data
                            })
                            let options = [];
                            options = [...response[att_id]];
                            arr = options;
                        });
                    return arr;
                }, 500)
            });
        } else {
            return this.state.dropdown_data[att_id]
        }
    }

    handleItemSelectChange = (index, option) => {
        let temp_att = this.props.filterAttributes[index];
        let {id} = temp_att.attribute;
        let val = option;
        let dropdowns = this.state.dropdown_data;
        if (!option) {
            val = ""
        } else if (Array.isArray(option)) {
            if (val.length < 1) {
                val = ""
            } else {
                // let data = [];
                // let option_vals = option.map(item => item.value);
                // dropdowns[id].forEach(item => {
                //     if (!option_vals.includes(item.value)) {
                //         data.push(item);
                //     }
                // });
                // dropdowns[id] = [...data].filter(val => val.value);
            }
        } else if (!Array.isArray(option)) {
            val = [option]
            // dropdowns[id] = dropdowns[id].filter(item => item.value);
        }

        this.setState({
            ...this.state,
            selectValue: {
                ...this.state.selectValue,
                [id]: {
                    ...this.state.selectValue[id],
                    filter_val: val
                }
            },
            // dropdown_data: dropdowns
        },() => {
            if(!val) {
                this.handleSelectBlur();
            }
        })
    }

    handleSelectBlur = async (e = null, att_id = null) => {
        let selected = {...this.state.selectValue};
        for (let key in selected) {
            if (typeof selected[key] !== 'string') {
                selected[key].search = ""
            }
        }
        if (att_id) {
            if (!selected[att_id].filter_val) {
                return;
            }
            const res = await this.props.getDropDownList(selected)
            let {dropdown_data} = this.state;
            for (let key in dropdown_data) {
                if (key != att_id) {
                    dropdown_data[key] = res[key];
                }
            }
            this.setState({
                dropdown_data
            })
        } else {
            const res = await this.props.getDropDownList(selected)
            let {dropdown_data} = this.state;
            for (let key in dropdown_data) {
                if (key != att_id) {
                    dropdown_data[key] = res[key];
                }
            }
            this.setState({
                dropdown_data
            })
        }
    }

    noOptionsMessage = () => {
        return "Type to search...";
    };
    // end

    handleSearchClick = e => {
        this.props.getLookupState(this.state.selectValue);
        setTimeout(() => {
            this.props.refreshList();
        }, 500);
    }

    onBrandSubmit = e => {
    };

    clearFilteredAttributes = async (e) => {
        let clear_values = {...this.state.selectValue};
        for (let key in clear_values) {
            if (typeof clear_values[key] !== 'string') {
                clear_values[key].filter_val = ""
            }
        }
        this.setState({
            selectValue: clear_values
        })
        const res = await this.props.getDropDownList(clear_values)
        let {dropdown_data} = this.state;
        for (let key in dropdown_data) {
            dropdown_data[key] = res[key];
        }
        this.setState({
            dropdown_data
        }, () => {
            console.log('cccc', this.state.dropdown_data)
        })
        this.props.getLookupState(clear_values);
        setTimeout(() => {
            this.props.refreshList();
        }, 500);
        // this.props.resetLookupState()
    }

    render() {
        let styleCss;
        let backgroundStyle;
        if (!this.props.showFiltersOnly) {
            styleCss = {paddingTop: "20px", maxWidth: "100%"};
            backgroundStyle = {background: "#f3f3f3"};
        } else {
            styleCss = {padding: "0px", maxWidth: "100%"};
            backgroundStyle = {background: "#FFF"};
        }

        return (
            <Grid fluid>
                <Row>
                    {!this.props.showFiltersOnly &&
                    <Col md={12}>
                        <div className="flexElem respFlex spaceBetween respFlex">
                            <div className="mb-lg">
                                <div className="brandInfo flexElem respFlex alignCenter">
                                    {
                                        this.props.selectedBrand &&
                                        <BrandLogo brand={this.props.selectedBrand} customClasses="ml-md text_16"/>
                                    }
                                </div>
                            </div>
                            <div>
                                <div className="brandInfo flexElem respFlex alignCenter">
                                    {
                                        this.props.selectedTag &&
                                        <TagLayoutInfo tag={this.props.selectedTag}/>
                                    }
                                </div>
                            </div>
                        </div>
                    </Col>
                    }

                    <Col md={12}>
                        <Card
                            ctTableResponsive
                            content={
                                <div>
                                    <Grid fluid>
                                        <Row>
                                            <Col md={12}>
                                                {!this.props.showFiltersOnly &&
                                                <h3
                                                    style={{
                                                        textAlign: "center",
                                                        fontWeight: "500"
                                                    }}
                                                >
                                                    Create Order
                                                </h3>
                                                }
                                                <form
                                                    onSubmit={
                                                        this.onBrandSubmit
                                                    }
                                                >
                                                    <div className="row">
                                                        <div
                                                            className="col-md-12"
                                                            style={backgroundStyle}
                                                        >
                                                            <div className="flexElem">
                                                                <h4
                                                                    className="clearfix"
                                                                    style={{
                                                                        marginTop:
                                                                            "12px"
                                                                    }}
                                                                >
                                                                    Enter PO /
                                                                    Style /
                                                                    Reference No
                                                                </h4>
                                                            </div>

                                                            <div
                                                                className="lookupPO flexElem alignCenter justifyCenter respFlex"
                                                                style={styleCss}
                                                            >
                                                                {this.props.filterAttributes.map(
                                                                    (item, index) => {
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div>
                                                                                    {/*<input*/}
                                                                                    {/*    type={"hidden"}*/}
                                                                                    {/*    name={this.props.name}*/}
                                                                                    {/*    defaultValue={*/}
                                                                                    {/*        this.state.selectValue.length > 0*/}
                                                                                    {/*            ? this.state.selectValue[index].value*/}
                                                                                    {/*            : ""*/}
                                                                                    {/*    }*/}
                                                                                    {/*/>*/}
                                                                                    {/*asdasdasdasd*/}
                                                                                    {/*<AsyncSelect*/}
                                                                                    {/*    cacheOptions={false}*/}
                                                                                    {/*    defaultOptions={true}*/}
                                                                                    {/*    loadOptions={(query, callback) =>*/}
                                                                                    {/*        this.loadOptions(query, callback, item.attribute.id)*/}
                                                                                    {/*    }*/}
                                                                                    {/*    onChange={(e) => {*/}
                                                                                    {/*        this.handleItemSelectChange(index, e)*/}
                                                                                    {/*    }}*/}
                                                                                    {/*    value={this.state.selectValue[item.attribute.id] ? this.state.selectValue[item.attribute.id].filter_val : ""}*/}
                                                                                    {/*    noOptionsMessage={this.noOptionsMessage}*/}
                                                                                    {/*    classNamePrefix="react-Selector"*/}
                                                                                    {/*    placeholder={`Select ${item.attribute.title}`}*/}
                                                                                    {/*    isClearable={true}*/}
                                                                                    {/*    isSearchable={true}*/}
                                                                                    {/*    isMulti={item.is_multiselect}*/}
                                                                                    {/*/>*/}

                                                                                    <Select
                                                                                        value={this.state.selectValue[item.attribute.id] ? this.state.selectValue[item.attribute.id].filter_val : ""}
                                                                                        onChange={(e) => {
                                                                                            this.handleItemSelectChange(index, e)
                                                                                        }}
                                                                                        onInputChange={(e) => {
                                                                                            this.onSelectInput(e, item.attribute.id)
                                                                                        }}
                                                                                        options={this.state.dropdown_data[item.attribute.id]}
                                                                                        isSearchable={true}
                                                                                        className='text-capitalize'
                                                                                        noOptionsMessage={this.noOptionsMessage}
                                                                                        isMulti={item.attribute.is_multiselect}
                                                                                        placeholder={`Select ${item.attribute.title}`}
                                                                                        isClearable={true}
                                                                                        onBlur={(e) => {
                                                                                            this.handleSelectBlur(e, item.attribute.id)
                                                                                        }}
                                                                                        closeMenuOnSelect={false}
                                                                                    />
                                                                                </div>
                                                                                {/*asdasdasd*/}
                                                                                {/*<AsyncSelectBox*/}
                                                                                {/*    attribute={item}*/}
                                                                                {/*    selectedFilter={this.props.selectedFilterAttributes.find(i => i !== undefined && i.attribute_id === item.product_attribute_id)}*/}
                                                                                {/*    returnState={this.props.getLookupState}*/}
                                                                                {/*    refreshList={this.props.refreshList}*/}
                                                                                {/*    ref={this.setSelectRef}*/}
                                                                                {/*/>*/}


                                                                            </React.Fragment>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button type="button"
                                                                onClick={this.handleSearchClick}
                                                                style={{
                                                                    maxWidth: '120px',
                                                                    marginTop: '10px',
                                                                    marginRight: '15px'
                                                                }}
                                                                className="customBtn btnBlack btn-lg">
                                                            Search
                                                        </button>
                                                        <button type="button"
                                                                onClick={this.clearFilteredAttributes}
                                                                style={{
                                                                    maxWidth: '120px',
                                                                    marginTop: '10px',
                                                                    marginRight: '15px',
                                                                    backgroundColor: 'tomato'
                                                                }}
                                                                className="customBtn btnBlack btn-lg">
                                                            Clear
                                                        </button>
                                                    </div>
                                                    {!this.props.showFiltersOnly &&
                                                    <div className="stepsNav mt-lg">
                                                        {
                                                            <div className="text-center">
                                                                <button type="button" onClick={() =>
                                                                    this.props.goToStep(
                                                                        this.props
                                                                            .prevStepNum
                                                                    )}
                                                                        className="stepNav prev"><MdNavigateBefore/>
                                                                </button>
                                                                <span className="display_ib mt-xs">Prev</span>
                                                            </div>
                                                        }

                                                        {
                                                            this.props.selectedFilterAttributes.length > 0 &&
                                                            <div className="text-center">
                                                                <button type="button"
                                                                        onClick={() => this.props.goToStep(
                                                                            this.props.nextStepNum === 3 ? 4
                                                                                : this.props.nextStepNum
                                                                        )}
                                                                        className="stepNav next"><MdNavigateNext/>
                                                                </button>
                                                                <span className="display_ib mt-xs">Next</span>
                                                            </div>
                                                        }
                                                    </div>
                                                    }
                                                </form>
                                            </Col>
                                        </Row>
                                    </Grid>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getDropDownList: (data) => {
            return dispatch(
                createOrderActions.getOrderFilterValues(data)
            );
        }
    };
};

export default withRouter(connect(null, mapDispatchToProps)(LookupPO));



// WEBPACK FOOTER //
// ./src/components/Admin/Order/LookupPO.jsx